// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1f3JO","requiredAsterisk":"Info_requiredAsterisk__3RPwq"};